import type { ReactNode } from "react";

import { confirmable } from "react-confirm";

import { CheckIcon, XIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";
import {
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from "simplydo/react/ui/modal";

type ConfirmModalProps = {
  show?: boolean;
  proceed?: () => void;
  dismiss?: () => void;
  cancel?: () => void;
  title: string;
  confirmation: ReactNode;
};

const ConfirmModal = ({
  show,
  proceed,
  dismiss,
  cancel,
  title,
  confirmation,
}: ConfirmModalProps) => {
  return (
    <Modal
      open={!!show}
      onClose={dismiss ?? (() => {})}
      basic
      size="small"
      className="no-scroll"
      closeOnDimmerClick={false}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalContent>
        <p>{confirmation}</p>
      </ModalContent>
      <ModalActions>
        <Button
          onClick={cancel ?? (() => {})}
          variant="outline"
          color="grey"
          style={{ color: "#fff" }}
        >
          <Icon icon={XIcon} /> Cancel
        </Button>
        <Button onClick={proceed ?? (() => {})} color="primary">
          <Icon icon={CheckIcon} /> Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default confirmable(ConfirmModal);
